<template>
  <div class="card" data-qa="company-card" @click="clickFullRow">
    <div class="header">
      <div class="title">
        <h4>{{ company.CustomerCompanyName }}</h4>
      </div>
    </div>

    <address itemscope itemtype="http://schema.org/Organization">
      <div itemprop="address">
        <span v-if="customerCompanyAddress" itemprop="streetAddress">
          {{ customerCompanyAddress }}
        </span>
        <template v-if="showMore">
          <br />
          <span v-if="company.CustomerCompanyZipcode" itemprop="postal-code">
            {{ company.CustomerCompanyZipcode }}
          </span>
        </template>
        <template v-else-if="customerCompanyAddress">, </template>
        <span v-if="company.CustomerCompanyCity" itemprop="locality">{{
          company.CustomerCompanyCity
        }}</span>
        <br />
      </div>

      <template v-if="company.CustomerCompanyEmail && showMore">
        {{ i18n.t('/Company/CompanyZoekenModal/CompanyCard/Emailaddress') }}
        <span itemprop="email" data-qa="company-email">{{ company.CustomerCompanyEmail }}</span
        ><br
      /></template>

      <template v-if="company.CustomerCompanyChamberOfCommerceNumber && showMore">
        {{ i18n.t('/Company/CompanyZoekenModal/CompanyCard/KvkNumber') }}
        <span itemprop="email" data-qa="company-email">{{
          company.CustomerCompanyChamberOfCommerceNumber
        }}</span
        ><br />
      </template>

      <template v-if="company.CustomerCompanyChamberOfCommerceEstablishmentNumber && showMore">
        {{ i18n.t('/Company/CompanyZoekenModal/CompanyCard/KvkLocationNumber') }}
        <span itemprop="email" data-qa="company-email">{{
          company.CustomerCompanyChamberOfCommerceEstablishmentNumber
        }}</span
        ><br />
      </template>

      <template v-if="company.CustomerCompanyPoId && showMore">
        {{ i18n.t('/Company/CompanyZoekenModal/CompanyCard/POID') }}
        <span data-qa="company-poid">{{ company.CustomerCompanyPoId }}</span
        ><br />
      </template>
      <template v-if="company.CustomerCompanyMagicNumber && showMore">
        {{ i18n.t('/Company/CompanyZoekenModal/CompanyCard/AutolineCustomerNr') }}
        <span data-qa="company-magic-number">{{ company.CustomerCompanyMagicNumber }}</span
        ><br />
      </template>
    </address>

    <div class="buttons">
      <app-button
        button-class="inverted--bordered btn-toggle-details"
        data-qa="toggle-company-details-button"
        @click.prevent.stop="toggleCompanyDetails"
      >
        {{
          i18n.t(
            showMore
              ? '/Company/CompanyZoekenModal/ToonMinderGegevens'
              : '/Company/CompanyZoekenModal/ToonMeerGegevens'
          )
        }}</app-button
      >
      <app-button
        button-class="primary"
        data-qa="choose-company-button"
        @click.stop="selectCompany"
      >
        {{ i18n.t('/Company/CompanyZoekenModal/CompanyCard/SelectCompany') }}
      </app-button>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import { mapState } from 'vuex'

export default {
  components: {
    AppButton,
  },
  inject: ['isNationalCompanySearch'],
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  emits: ['selectResult'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showMore: false,
      detailsRetrieved: false,
    }
  },
  computed: {
    ...mapState('user', ['dealerSettings']),
    customerCompanyAddress() {
      return this.company.CustomerCompanyAddress || this.company.CustomerCompanyStreet
    },
    searchEsb() {
      return !this.isNationalCompanySearch() && this.dealerSettings.autolineKeyloopEnabled
    },
  },
  methods: {
    selectCompany() {
      if (this.searchEsb) {
        this.getCompanyDetails().then(() => {
          this.$emit('selectResult', this.company)
        })
      } else {
        this.$emit('selectResult', this.company)
      }
    },
    clickFullRow(event) {
      this.selectCompany()
    },
    toggleCompanyDetails() {
      if (!this.showMore && this.searchEsb) {
        this.getCompanyDetails().then(() => {
          this.showMore = !this.showMore
        })
      } else {
        this.showMore = !this.showMore
      }
    },
    async getCompanyDetails() {
      if (!this.detailsRetrieved) {
        await this.$store.dispatch(
          'companies/getCompanyByMagicNumber',
          this.company.CustomerCompanyMagicNumber
        )
        this.detailsRetrieved = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  border: 1px solid $gray-light;
  margin-bottom: $gutter;
  padding: $gutter;
  transition: background-color 0.2s ease-out;
  cursor: pointer;

  &:hover {
    background: #f8f8f8;
  }
}

.header {
  margin-bottom: 0.5em;

  @include breakpoint(md) {
    display: flex;
    align-items: flex-start;
  }
}

.title {
  margin-right: 0.5em;

  h4 {
    display: inline;
  }
}

.info-label {
  flex: 0 0 auto;
  background: $gray-lightest;
  margin-bottom: 1em;
  padding: 0.25em 0.5em;
  display: inline-flex;
  align-items: center;
  max-width: 100%;

  @include breakpoint(md) {
    display: flex;
    margin: 0 0 0 auto;
  }
}

.icon-info-label {
  @include icon();

  margin-right: 0.25em;
}

address {
  margin-bottom: 1em;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.btn-toggle-details {
  color: inherit;
}
</style>
